import React from "react";
import useCareLabels from "hooks/useCareLabels";
import CareLabelSkeleton from "../CareLabelSkeleton/CareLabelSkeleton";

/** Renders Consumer/Participant label or skeleton while care sector loads. */
const CareLabelText = ({
  plural = false,
  skeletonWidth,
  skeletonClassName = "bg-gray-200",
  className = "",
}) => {
  const { participantLabel, participantLabelPlural, isLoading } = useCareLabels();

  if (isLoading) {
    return (
      <CareLabelSkeleton
        width={skeletonWidth || (plural ? "w-28" : "w-24")}
        className={skeletonClassName}
      />
    );
  }

  return (
    <span className={className}>
      {plural ? participantLabelPlural : participantLabel}
    </span>
  );
};

export default CareLabelText;
